import { useEffect } from 'react'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { PREV_URL } from '@/common/constants/cookies'

const useAmplitudeVisiblePage = (page, isAddedRefferal) => {
  useEffect(() => {
    const prevUrl = localStorage.getItem(PREV_URL) || '/'
    const payload = { ...(isAddedRefferal ? { source: prevUrl } : {}) }
    
    userAmplitudeAnalytics.trackEvent(`${page}_page_shown`, payload)
  }, [])
}

export default useAmplitudeVisiblePage
